var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 439,
    viewBox: "0 0 800 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_138_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 390C18.6667 380.333 34.5833 370.583 47.75 360.75C61.0833 350.917 69.5833 344.167 73.25 340.5L69.75 198.5V110.5L8.75 103.75L18 47.5L49 51.5C89 56.5 117.917 61.8333 135.75 67.5L129.75 348C129.75 355.667 128.333 361.583 125.5 365.75C119.167 375.417 111.083 384.167 101.25 392C91.4167 399.833 83 406.25 76 411.25C59.3333 423.25 45 432.25 33 438.25L0 390ZM270.75 0C272.583 6.5 273.5 13.8333 273.5 22C273.5 30 273.25 36.8333 272.75 42.5C272.25 48 271.667 53.1667 271 58C269.333 68.5 267.417 75.6667 265.25 79.5L207.75 77C210.583 62.3333 212 38.9167 212 6.75L270.75 0ZM268.75 126C269.583 143.167 270 157.583 270 169.25C270 180.917 269.75 194.583 269.25 210.25L263.5 376.25L210.25 380.75L205.25 134L268.75 126ZM327.25 336.25C327.25 336.25 345.083 335.167 380.75 333C397.25 332 413.833 330.333 430.5 328L432.25 296.5L344.5 262C339.333 260 335.417 256.167 332.75 250.5C330.083 244.667 328.75 240.083 328.75 236.75C328.75 233.417 328.75 231.333 328.75 230.5C328.917 229.5 329.167 227.25 329.5 223.75L335 176.5C336.667 163.167 343.417 153.917 355.25 148.75C362.583 145.417 371.833 142.417 383 139.75C405.833 134.417 421.833 130.833 431 129L455.25 123.75C462.25 122.417 468.5 121.25 474 120.25L485.5 177.5L388 192L384 216L476.25 259C487.417 264.167 492.167 274.083 490.5 288.75L483.75 349C482.25 361.833 471.833 370.417 452.5 374.75C431.833 380.417 408.917 384.583 383.75 387.25C358.75 390.083 342.25 391.667 334.25 392L327.25 336.25ZM546.25 71L607.25 59.25V137.75L670 126L674.75 182.75L608.25 187.75L603.5 323C615.833 326.833 626.5 329.833 635.5 332C658 337.333 671.75 340.667 676.75 342L663.5 394.25C626.5 386.083 594.083 376.667 566.25 366C554.917 361.833 549.25 354.333 549.25 343.5L546.25 71ZM737.5 44.75L798.5 33.5L799.5 104.5L787.75 264.25L740 261.25L737.5 44.75ZM793.75 309.25C795.583 315.583 796.5 322.583 796.5 330.25C796.5 337.75 796.25 344.083 795.75 349.25C795.25 354.417 794.667 359.25 794 363.75C792.333 373.25 790.417 380 788.25 384L732.5 377.75C734 366.25 734.917 353.583 735.25 339.75C735.75 325.75 736.167 316.583 736.5 312.25L793.75 309.25Z",
    fill: "url(#paint0_linear_138_29)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_138_29",
    x: 0,
    y: 0,
    width: 799.5,
    height: 446.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_138_29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_138_29",
    x1: 416.5,
    y1: 2.25,
    x2: 416.5,
    y2: 450.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.5e5bbcb3ce05f0bc8f5db0c0d1f5eeeb.svg";
export { ForwardRef as ReactComponent };